// One home for how strongly a regulatory layer's fill is drawn (BBB-457).
//
// This lives on its own because the same number has to hold in three places: the
// polygon the adapter draws, the per-source override in the catalogue, and the
// legend swatch. When they drifted apart the key silently misrepresented the map —
// exactly the defect logged against nvz-scotland, where the swatch shows a 22%
// tint over a fill the map renders at 59%.
//
// The fill exists so a farmer can tell which side of a boundary is inside the
// designation; at farm zoom you often see one edge and no other cue. It is not
// meant to read as a solid shaded area.

/** Designations (SSSI, SAC, SPA). Raised from 0.12 on 12/08/2026 — too faint. */
export const DEFAULT_FILL_OPACITY = 0.22;

/**
 * Nitrate Vulnerable Zones and Drinking Water Safeguard Zones.
 *
 * Deliberately below the default, and the gap is load-bearing rather than
 * cosmetic. `precedence` is the Google Maps zIndex, and drwpa-england's is 200
 * against 100-120 for the three designations — so it draws OVER them. At the
 * default opacity its wash would bury the SSSI/SAC/SPA boundaries underneath,
 * which is the layer a farmer most needs to read. These two also cover a large
 * share of England, which was the original BBB-456 complaint.
 */
export const LARGE_AREA_FILL_OPACITY = 0.12;

/**
 * A fill opacity as the two-digit hex alpha suffix for a #RRGGBB colour.
 *
 * Hex alpha rather than color-mix(), which needs a much newer browser — and an
 * older browser drops a color-mix() declaration outright, costing the swatch its
 * fill altogether rather than just its exact shade. This is a farmer-facing app
 * where device age cannot be assumed.
 *
 * @param {number} opacity 0-1
 * @returns {string} e.g. 0.22 -> '38' (56/255 = 21.96%)
 */
export function fillHexAlpha(opacity) {
  return Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0')
    .toUpperCase();
}
